module.exports = __webpack_public_path__ + "static/img/rapid-en-US.999bc18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rapid-en-US.png
// module id = 4p0A
// module chunks = 1